import axios from "axios";
import { environment, adminEnvironment } from "./environments/environment.development";


export const requestWithoutToken = async (method: any, url: any, body?: any) => {
  let request;
  url = environment.apiUrl + url;
  switch (method) {
    case "GET":
      request = await axios.get(url);
      break;
    case "POST":
      request = await axios.post(url, body);
      break;
    default:
      break;
  }

  return request;
};

// export const requestAdminWithoutToken = async (method: any, url: any, body?: any) => {
//   let request;
//   url = adminEnvironment.apiUrl + url;
//   switch (method) {
//     case "GET":
//       request = await axios.get(url);
//       break;
//     case "POST":
//       request = await axios.post(url, body);
//       break;
//     default:
//       break;
//   }

//   return request;
// };


export const requestWithToken = async (
  method: any,
  endUrl: any,
  body?: any,
  responseType?: any
) => {
  let request;
  let url = environment.apiUrl + endUrl;

  const headers: any = {
    headers: {
      Authorization: `${localStorage.getItem("marieTokenAdmin")}`,
    },
  };
  if (responseType) {
    headers[`responseType`] = responseType;
  }
  switch (method) {
    case "GET":
      request = await axios.get(url, headers);
      break;
    case "POST":
      request = await axios.post(url, body, headers);
      break;
    case "PUT":
      request = await axios.put(url, body, headers);
      break;
    case "DELETE":
      request = await axios.delete(url, {
        data: body,
        headers: headers.headers,
      });
      break;

    default:
      break;
  }

  return request;
};


// export const requestAdminWithToken = async (
//   method: any,
//   endUrl: any,
//   body?: any,
//   responseType?: any
// ) => {
//   let request;
//   let url = environment.apiUrl + endUrl;

//   const headers: any = {
//     headers: {
//       Authorization: `${localStorage.getItem("marieToken")}`,
//     },
//   };
//   if (responseType) {
//     headers[`responseType`] = responseType;
//   }
//   switch (method) {
//     case "GET":
//       request = await axios.get(url, headers);
//       break;
//     case "POST":
//       request = await axios.post(url, body, headers);
//       break;
//     case "PUT":
//       request = await axios.put(url, body, headers);
//       break;
//     case "DELETE":
//       request = await axios.delete(url, {
//         data: body,
//         headers: headers.headers,
//       });
//       break;

//     default:
//       break;
//   }

//   return request;
// };
